var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-main-wrap boss-main-content-wrap" },
    [
      _c("setting-header", {
        attrs: {
          breadcrumbs: [
            { name: "社員からの評判", pathName: "realIntentionTop" },
          ],
          title: "社員からの評判＿" + _vm.title,
          "data-test": "title-real-intention",
        },
      }),
      _vm._v(" "),
      _c("div", [
        _c("span", { staticClass: "text-center margin-2" }, [
          _c("div", {
            attrs: { "data-test": "notification-first-line" },
            domProps: { textContent: _vm._s(_vm.notificationFirstLine) },
          }),
          _vm._v(" "),
          _c("div", {
            attrs: { "data-test": "notification-second-line" },
            domProps: { textContent: _vm._s(_vm.notificationSecondLine) },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("real-intention-preview-content", {
            attrs: {
              "real-intention": _vm.realIntentionPreviewContent,
              "inner-style": "border: 1px solid #777777;",
              "data-test": "real-intention-preview-content",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "form-button-area",
            [
              _c("form-back-button", {
                attrs: { "data-test": "back-button" },
                on: { back: _vm.back },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "form-button-area",
            [
              _c("form-confirm-button", {
                staticClass: "pega-unpublish-button",
                attrs: {
                  "submit-label": "非公開で保存する",
                  "data-test": "unpublish-button",
                },
                on: { "submit-event": _vm.onUnPublishRegisterClick },
              }),
              _vm._v(" "),
              _c("form-confirm-button", {
                attrs: {
                  "submit-label": "この内容で公開する",
                  "data-test": "publish-button",
                },
                on: { "submit-event": _vm.onPublishRegisterClick },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }